import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubblePen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17 11L22.5 5.5L19.5 2.5L14 8.00002V11H17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12.7568 5H3V21H3.41602L5.37891 17.5098L5.66504 17H21V11.2461L23 9.24609V19H6.83398L4.87109 22.4902L4.58496 23H1V3H14.7568L12.7568 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconChatBubblePen.js.map